<app-video-call *ngIf="consulta" [consulta]="consulta"></app-video-call>
